export function decodeJwtPayload(token) {
    if (!token)
        return null;
    try {
        const base64Url = token.split(".")[1];
        if (!base64Url)
            return null;
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join(""));
        return JSON.parse(jsonPayload);
    }
    catch {
        return null;
    }
}
export function isJwtExpired(token) {
    const payload = decodeJwtPayload(token);
    if (!payload?.exp)
        return true;
    return payload.exp * 1000 < Date.now();
}
/**
 * Decodes and validates a CSA JWT, returning the standard claims.
 * Returns null if the token is missing required claims or is expired.
 */
export function parseCsaToken(token) {
    const payload = decodeJwtPayload(token);
    if (!payload?.id || !payload?.name)
        return null;
    if (isJwtExpired(token))
        return null;
    return { id: String(payload.id), username: String(payload.name) };
}
